import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authService } from '../lib/api/auth';
import { HRMSUserType } from '../types/auth';
import { tokenManager } from '../lib/token-manager';
import { sessionStorageClearAll } from '../components/storage/sessionStorageManager';
import { localStorageRemoveItem } from '../components/storage/localStorageManager';
import { routes } from '../containers/routes/routes-names';
import { AppDispatch } from './index';
import { useNavigate } from 'react-router-dom';

type InitialStateType = {
    hrmsLoading: boolean;
    hrmsUser: HRMSUserType | null;
};

const initialState: InitialStateType = {
    hrmsLoading: true,
    hrmsUser: null,
};

const hrmsSlice = createSlice({
    name: 'hrms',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.hrmsLoading = action.payload;
        },
        setHRMSUser(state, action: PayloadAction<HRMSUserType>) {
            state.hrmsUser = action.payload;
        },
        deleteHRMSUser(state) {
            state.hrmsUser = initialState.hrmsUser;
            sessionStorageClearAll();
        },
    },
});

export function getHRMSUser(navigate?: ReturnType<typeof useNavigate>) {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(hrmsSlice.actions.setLoading(true));
            const user = await authService.getHRMSUser();
            if (user.resultObject.suspendedStatus === 1 || user.resultObject.joinStatus === 2) {
                signOutHRMSForceFully();
            }

            if (user) {
                dispatch(hrmsSlice.actions.setHRMSUser(user.resultObject));
            }
        } catch (err) {
            // history.push(routes.main);
            navigate?.(routes.main);
        } finally {
            dispatch(hrmsSlice.actions.setLoading(false));
        }
    };
}

export function signHRMSOut(navigate?: ReturnType<typeof useNavigate>) {
    return async (dispatch: AppDispatch) => {
        dispatch(hrmsSlice.actions.deleteHRMSUser());
        localStorageRemoveItem('hrmsuserApiToBeRun');
        tokenManager.removeToken();
        // history.push(routes.main);
        navigate?.(routes.main);
    };
}

export function signOutHRMSForceFully(navigate?: ReturnType<typeof useNavigate>) {
    hrmsSlice.actions.deleteHRMSUser();
    tokenManager.removeToken();
    localStorageRemoveItem('hrmsuserApiToBeRun');
    // history.push(routes.main);
    navigate?.(routes.main);
    window.location.reload();
}

export default hrmsSlice.reducer;
export const { setLoading } = hrmsSlice.actions;
